<script lang="ts" setup>
import { useErrorHandler } from '@errors/useErrorHandler';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { CrmDomeinVerificatieGetDomeinenPerAdviseurResponse as Domein } from '@services/crm-public/orval-api/model/crmDomeinVerificatieGetDomeinenPerAdviseurResponse';
import VButton from '@shared/component/VButton/VButton.vue';
import { useNotification } from '@shared/plugin/prime-vue/useNotification';
import { useQueryClient } from '@tanstack/vue-query';
import {
  getDomeinVerificatieGetDomeinenQueryKey as getDomeinenQueryKey,
  useDomeinVerificatieCheckStatus,
} from '@services/crm-public/orval-api/domein-verificatie/domein-verificatie';
import { useFieldValue } from 'vee-validate';
import type { CrmAdviseursGetAdviseursDto as Adviseur } from '@services/crm-internal/api';

export type CheckStatusButtonProps = {
  domain: Domein['domein'];
};

const props = defineProps<CheckStatusButtonProps>();

const { handleError } = useErrorHandler();
const adviseur = useFieldValue<Adviseur | undefined>('adviseur');
const notification = useNotification();
const queryClient = useQueryClient();

const checkStatusGet = useDomeinVerificatieCheckStatus(
  { domein: props.domain },
  {
    query: { enabled: false },
  },
);

const checkStatus = () =>
  checkStatusGet
    .refetch({
      throwOnError: true,
    })
    .then(onCheckStatusSuccess)
    .catch(handleError);

async function onCheckStatusSuccess() {
  notification.success(`De status voor ${props.domain} is bijgewerkt`);

  await queryClient.invalidateQueries({
    queryKey: getDomeinenQueryKey({ adviseurnummer: adviseur.value?.adviseurnummer }),
  });
}
</script>

<template>
  <VButton
    aria-label="Controleren"
    :disabled="checkStatusGet.isLoading.value"
    font-size="sm"
    hide-shadow
    inverted
    size="sm"
    title="Controleren"
    @click="checkStatus"
  >
    <FontAwesomeIcon
      class="animation-duration-1000"
      :icon="faArrowsRotate"
      :spin="checkStatusGet.isLoading.value"
    />
  </VButton>
</template>
